// Overlaps the next tick or two during the sweep. Much longer and the file's tail piles up at 22
// ticks a second.
const TICK_SECONDS = 0.08
// Ramped out rather than cut, so the end of each tick does not click on its own.
const FADE_SECONDS = 0.01
// Below this a sample counts as the file's leading padding.
const SILENCE = 0.01

/** Restart and play. A blocked or missing sound must not surface as an error mid-draw. */
export const playFromStart = (audio) => {
  audio.currentTime = 0
  audio.play().catch(() => {})
}

/**
 * Decodes the flash tick into `context` and returns its player. Web Audio, so each play is its own
 * voice: restarting one element every 45 ms cut every click short. Silent until decoded.
 */
export const loadTick = (context, url) => {
  let buffer = null
  let onset = 0

  fetch(url)
    .then((response) => response.arrayBuffer())
    .then((data) => context.decodeAudioData(data))
    .then((decoded) => {
      // Skips the MP3's leading padding, which would otherwise eat into a short tick.
      const first = decoded.getChannelData(0).findIndex((sample) => Math.abs(sample) > SILENCE)
      onset = Math.max(first, 0) / decoded.sampleRate
      buffer = decoded
    })
    .catch(() => {})

  /** Plays `seconds` of the file from its onset; Infinity plays it to the end. */
  const play = (seconds = TICK_SECONDS) => {
    // Created before any press, so it can start suspended, and its clock stands still until it
    // runs: ticks scheduled meanwhile would all fire at once. Dropped instead.
    if (context.state !== 'running') {
      context.resume()

      return
    }

    if (!buffer) return

    // Clamped to the file, since the scheduling calls below reject Infinity.
    const length = Math.min(seconds, buffer.duration - onset)
    const now = context.currentTime
    const source = context.createBufferSource()
    const gain = context.createGain()

    source.buffer = buffer
    gain.gain.setValueAtTime(1, now + length - FADE_SECONDS)
    gain.gain.linearRampToValueAtTime(0, now + length)
    source.connect(gain).connect(context.destination)
    source.start(now, onset, length)
  }

  return play
}
